import { useState } from "react";
import { faqs } from "@/mocks/crash";
import SectionHeading from "./SectionHeading";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <section id="faq" className="relative bg-paper-50 py-16 md:py-24 scroll-mt-16">
      <span id="manual" aria-hidden="true" className="absolute top-0"></span>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />

      <div className="mx-auto max-w-6xl px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_1.5fr] gap-10 lg:gap-16">
          <div className="lg:sticky lg:top-24 self-start">
            <SectionHeading
              eyebrow="MANUAL · 吃瓜手册"
              title="理性吃瓜，从这里开始"
              desc="关于「女神塌房」「人设崩塌」，你真正想问的问题，或许都在这份手册里。每一个答案，都是客观现象与事实判断，不含主观站队。"
            />
            <div className="mt-6 inline-flex items-center gap-2 rounded-full bg-paper-100 border border-paper-200 px-4 py-2 text-sm text-ink-700/80">
              <i className="ri-question-line text-coral-600"></i>
              先看实锤，再谈立场
            </div>
          </div>

          <div className="flex flex-col gap-3">
            {faqs.map((f, i) => {
              const open = openIdx === i;
              return (
                <div
                  key={f.q}
                  className={`overflow-hidden rounded-xl border transition-colors ${
                    open ? "border-coral-200 bg-coral-50/40" : "border-paper-200 bg-paper-50"
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setOpenIdx(open ? -1 : i)}
                    aria-expanded={open}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                  >
                    <span className="flex items-center gap-3 text-ink-900 font-semibold leading-snug">
                      <span className="inline-flex items-center justify-center shrink-0 w-6 h-6 rounded-full bg-ink-900 text-paper-50 text-xs font-bold">
                        Q
                      </span>
                      {f.q}
                    </span>
                    <i
                      className={`shrink-0 text-coral-600 transition-transform ${open ? "ri-subtract-line" : "ri-add-line"}`}
                    ></i>
                  </button>
                  {open && (
                    <div className="px-5 pb-5 pl-14 text-ink-700/85 leading-relaxed text-sm">
                      {f.a}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}